import React from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Card } from 'react-bootstrap';
import messages from '../messages.js';
import DataProtectionOfficer from './DataProtectionOfficer/index.jsx';
import Account from './Account/index.jsx';

function Details() {
  return (
    <Card>
      <Card.Header className="border-0">
        <h2 className="card-title"><FormattedMessage {...messages.schoolDetails} /></h2>
      </Card.Header>
      <Card.Body className="pt-0">
        <Account />
        <DataProtectionOfficer />
      </Card.Body>
    </Card>
  );
}

export default Details;
